"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var textbox_1 = require("../textbox");
var search_1 = require("adp-react-icons/lib/fa/search");
var localizers_1 = require("../util/localizers");
function localizedMessage(messageKey, locale) {
    return localizers_1.message.formatMessage('adp-react-components/masthead/' + messageKey, undefined, locale);
}
exports.MastheadSearch = function (props) {
    var _a;
    var className = props.className, onSearch = props.onSearch;
    var textboxProps = _1.pick(props, Object.keys(textbox_1.Textbox.propTypes));
    var customProps = _1.omit(props, Object.keys(textbox_1.Textbox.propTypes).concat(Object.keys(exports.MastheadSearch.propTypes)));
    var rootClasses = (_a = {},
        _a[vdl_prefix_1.vdlPrefix('masthead-search')] = true,
        _a);
    return (React.createElement("div", __assign({}, customProps, { className: classnames_1.classNames(className, rootClasses) }),
        React.createElement(textbox_1.Textbox, __assign({}, textboxProps, { className: vdl_prefix_1.vdlPrefix('masthead-search__textbox'), placeholder: localizedMessage('SEARCH', props.locale) })),
        React.createElement("div", { className: vdl_prefix_1.vdlPrefix('masthead-search__icon'), onClick: onSearch },
            React.createElement(search_1.default, null))));
};
exports.MastheadSearch.propTypes = Object.assign({}, textbox_1.Textbox.propTypes, {
    onSearch: PropTypes.func,
    locale: PropTypes.string
});
exports.MastheadSearch.displayName = 'MastheadSearch';
